import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pagemapping',
  templateUrl: './pagemapping.component.html',
  styleUrls: ['./pagemapping.component.css']
})
export class PagemappingComponent implements OnInit {
  checked: boolean = false;
  checkedUn: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  checkUncheckAll(){
    if(!this.checked)
    {
      this.checked = true;
      console.log("in if :",this.checked)
  }
   else{
     this.checked = false
     console.log("in else :",this.checked)
   }

  }

  checkUncheckAllUnassignPages(){
    if(!this.checkedUn)
    {
      this.checkedUn = true;
      console.log("in if :",this.checked)
  }
   else{
     this.checkedUn = false
     console.log("in else :",this.checked)
   }
  }
}
